module.exports = __webpack_public_path__ + "static/fourpcpinkfloralmain-05c49f49e0b3841661876191b397b906.jpeg";